import {Button, FormControl, Stack, TextField} from "@mui/material";
import {useState} from "react";
import {useCreateUserWithEmailAndPassword, useSendPasswordResetEmail, useSignInWithEmailAndPassword} from "react-firebase-hooks/auth";
import {useHistory} from "react-router-dom";
import {auth} from "../firebase/index.js";
import APXErrorAlert, {useErrorAlert} from "./APXErrorAlert.jsx";
import APXSuccessAlert, {useSuccessAlert} from "./APXSuccessAlert.jsx";
import {DASHBOARD, HOME} from "./js/AppRoutes.js";


const signUp = <SignUp/>;
const login = <Login/>;
const forgotPassword = <ForgotPassword/>;

let changeForm;

export default function APXAuthenticationForm() {
	  const [form, setForm] = useState(login);
	  changeForm = setForm;
	  return (form);
}


//********************************************************************************
//* SIGN UP
//********************************************************************************

function SignUp() {
	  const history = useHistory();
	  const [
			 createUserWithEmailAndPassword,
			 user,
			 loading,
			 error
	  ] = useCreateUserWithEmailAndPassword(auth);
	  const [email, setEmail] = useState("");
	  const [password, setPassword] = useState("");
	  const [confirmPassword, setConfirmPassword] = useState("");
	  
	  const [show, setShow] = useErrorAlert([email, password]);
	  
	  
	  function handleSignUp() {
			 if (email.match(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/) !== null && password !== "" && confirmPassword !== "" && password === confirmPassword) {
					// history.replace(HOME.path);
					createUserWithEmailAndPassword(email, password)
							  .then(
										 (userCredential) => !!userCredential && history.replace(HOME.path),
							  );
			 } else {
					setShow(true);
			 }
	  }
	  
	  
	  return (
				 <>
						<Stack spacing={2} maxWidth={360} margin={"0 auto"} direction={"column"} justifyContent={"center"} alignItems={"center"}
								 alignSelf={"center"} p={2} my={12}>
							  <FormControl fullWidth>
									 <TextField label="Email" type="email" required value={email} onChange={(event) => setEmail(event.target.value)}/>
							  </FormControl>
							  <FormControl fullWidth>
									 <TextField label="Password" type="password" required value={password} onChange={(event) => setPassword(event.target.value)}/>
							  </FormControl>
							  <FormControl fullWidth>
									 <TextField label="Confirm Password" type="password" required value={confirmPassword}
													onChange={(event) => setConfirmPassword(event.target.value)}/>
							  </FormControl>
							  {show && <APXErrorAlert message={"Invalid email, password, or confirm password."}/>}
							  <FormControl fullWidth>
									 <Button variant="contained" color="primary" fullWidth onClick={handleSignUp}>
											Sign Up
									 </Button>
							  </FormControl>
							  <FormControl fullWidth>
									 <Button variant="outlined" color="primary" fullWidth onClick={() => changeForm(login)}>
											Back to Login
									 </Button>
							  </FormControl>
						</Stack>
				 </>
	  );
}


//********************************************************************************
//* LOGIN
//********************************************************************************

function Login() {
	  const history = useHistory();
	  const [
			 signInWithEmailAndPassword,
			 user,
			 loading,
			 error
	  ] = useSignInWithEmailAndPassword(auth);
	  const [email, setEmail] = useState("");
	  const [password, setPassword] = useState("");
	  
	  const [show, setShow] = useErrorAlert([email, password]);
	  
	  
	  function handleLogin() {
			 if (email.match(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/) !== null && password !== "") {
					// history.replace(DASHBOARD.path);
					signInWithEmailAndPassword(email, password)
							  .then(
										 (userCredential) => !!userCredential && history.replace(DASHBOARD.path),
							  );
			 } else {
					setShow(true);
			 }
	  }
	  
	  
	  return (
				 <>
						<Stack spacing={2} maxWidth={360} margin={"0 auto"} direction={"column"} justifyContent={"center"} alignItems={"center"}
								 alignSelf={"center"} p={2} my={12}>
							  <FormControl fullWidth>
									 <TextField label="Email" type="email" required value={email} onChange={(event) => setEmail(event.target.value)}/>
							  </FormControl>
							  <FormControl fullWidth>
									 <TextField label="Password" type="password" required value={password} onChange={(event) => setPassword(event.target.value)}/>
							  </FormControl>
							  {show && <APXErrorAlert message={"Invalid email or password."}/>}
							  <FormControl fullWidth>
									 <Button variant={"outlined"} color={"primary"} onClick={() => changeForm(forgotPassword)}>
											Forgot Password
									 </Button>
							  </FormControl>
							  <FormControl fullWidth>
									 <Button variant="contained" color="primary" fullWidth onClick={handleLogin}>
											Login
									 </Button>
							  </FormControl>
							  <FormControl fullWidth>
									 <Button variant="contained" color="primary" fullWidth onClick={() => changeForm(signUp)}>
											Sign Up
									 </Button>
							  </FormControl>
						</Stack>
				 </>
	  );
}


//********************************************************************************
//* FORGOT PASSWORD
//********************************************************************************

function ForgotPassword() {
	  const history = useHistory();
	  const [
			 sendPasswordResetEmail,
			 sending,
			 error] = useSendPasswordResetEmail(auth);
	  const [email, setEmail] = useState("");
	  
	  const [show, setShow] = useErrorAlert([email]);
	  
	  const [showSuccess, setSuccess] = useSuccessAlert();
	  
	  
	  function handleForgotPassword() {
			 if (email.match(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/) !== null) {
					setSuccess(true);
					setTimeout(() => changeForm(login), 2000);
					sendPasswordResetEmail(email)
							  .then(
										 () => {
												setSuccess(true);
												changeForm(login);
										 },
							  );
			 } else {
					setShow(true);
			 }
	  }
	  
	  
	  return (
				 <>
						<Stack spacing={2} maxWidth={360} margin={"0 auto"} direction={"column"} justifyContent={"center"} alignItems={"center"}
								 alignSelf={"center"} p={2} my={12}>
							  <FormControl fullWidth>
									 <TextField label="Email" type="email" disabled={showSuccess} required value={email}
													onChange={(event) => setEmail(event.target.value)}/>
							  </FormControl>
							  {show && <APXErrorAlert message={"Invalid email."}/>}
							  {showSuccess && <APXSuccessAlert message={"Password reset email sent."}/>}
							  <FormControl fullWidth>
									 <Button variant="contained" disabled={showSuccess} color="primary" fullWidth onClick={handleForgotPassword}>
											Reset Password
									 </Button>
							  </FormControl>
							  <FormControl fullWidth>
									 <Button variant="outlined" disabled={showSuccess} color="primary" fullWidth onClick={() => changeForm(login)}>
											Back to Login
									 </Button>
							  </FormControl>
						</Stack>
				 </>
	  );
}